import importExportComponents from "../../../../../web-sh/src/pages/admin/settings/components/import-export";

import Import from "./Import";

importExportComponents.Import = Import;

export default importExportComponents